import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PermissionGroup } from '../permission-groups-data-table/permission-group.model';
import { ILookup } from '../../shared-module/common/interfaces/ILookup.interface';
import { KeyValuePair } from "../../shared-module/common/models/KeyValuePair.model";
import { UrlPrefix } from "../../shared-module/common/constants/url-prefix.constants";

@Injectable()
export class AddEditPermissionGroupService {

  constructor(private http: HttpClient) { }

  public getPermissionGroup(permissionId: number): Observable<PermissionGroup> {
    return this.http.get<PermissionGroup>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/permissionGroups/${permissionId}`);
  }

  public save(permissionGroup: PermissionGroup): Observable<number> {
    return this.http.post<number>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/permissionGroups`, JSON.stringify(permissionGroup));
  }
}
